

(function () {
  let zendeskLoaded = false;
  let zendeskLoading = false;
  let zendeskOpened = false;

  const ZENDESK_KEY = 'a3439747-311f-465f-b8d2-3323c113268f';
  window.UG_ZENDESK_TRANSFER_CONFIG = {
    ticketApiUrl: 'https://tiger-public-api.seougreen.workers.dev/api/v1/integrations/quickcep/zendesk-ticket', // 必填才会拉历史并预建工单
    openZendeskAfterTicketFails: true, // 工单接口失败是否仍打开 Zendesk（默认 true）
    additionalHeaders: {},
    additionalBodyFields: {}, // 可覆盖 JSON Body；与 tiger-public-api POST body 对齐：chatSubSessionId / visitorName / visitorEmail
    /**
     * Messenger：`chatSubSessionId` 与 REST 预建工单一致时，客服可按「QuickCEP 子会话」对齐两边。
     * `id` 为 Zendesk 该自定义字段的数字 id（字符串形式）。
     */
    messengerConversationFieldIds: {
      chatSubSessionId: '16118478216079',
    },
  };

  /**
   * 历史工单：仅在「你们在页面里配置 ticketApiUrl」时生效。
   *
   * 鉴权（不要把 Workers 上的长期 PUBLIC_API_SECRET 写进静态 JS）：
   * 1) 推荐：ticketApiUrl 指向你们「同源或自家后端」代理，服务端加 Authorization: Bearer … 再转发到
   *    …/api/v1/integrations/quickcep/zendesk-ticket（Workers 侧可设 PUBLIC_API_ZENDESK_TICKET_REQUIRE_BEARER）。
   * 2) 或：ticketApiUrl 仍指 Worker，但用 getTicketFetchInit 异步向你们后端取短期 token（非长期 secret），再写入 headers。
   * 3) 勿：在 additionalHeaders 里硬编码长期 Bearer — 任何人打开页面即可盗用。
   *
   * 可选在引入本脚本之前设置：
   *   window.UG_ZENDESK_TRANSFER_CONFIG = {
   *     ticketApiUrl: 'https://store.example.com/apps/xxx/quickcep/zendesk-ticket',
   *     openZendeskAfterTicketFails: true,
   *     additionalHeaders: {},
   *     additionalBodyFields: {},
   *     messengerConversationFieldIds: {
   *       chatSubSessionId: 'QuickCEP 子会话 字段 id',
   *     },
   *     // getTicketFetchInit: async (defaultInit, ctx) => ({ ...defaultInit, headers: { ...defaultInit.headers, Authorization: 'Bearer ' + token } }),
   *   };
   */

  /** 从 QuickChat goThirdPlatform 载荷里解析子会话 id（字段名以快牛实际回调为准） */
  function pickChatSubSessionId(data) {
    if (data == null) {
      return '';
    }
    if (typeof data === 'string') {
      return data.trim();
    }
    if (typeof data === 'object') {
      var v =
        data.chatSubSessionId ||
        data.chat_sub_session_id ||
        data.chatSubSessionID ||
        (data.chatSubSession && data.chatSubSession.id) ||
        (data.payload && (data.payload.chatSubSessionId || data.payload.chat_sub_session_id)) ||
        '';
      return String(v).trim();
    }
    return '';
  }

  function pickVisitorName(data) {
    if (data && typeof data === 'object') {
      var payload = data.payload && typeof data.payload === 'object' ? data.payload : {};
      var n =
        data.visitorName ||
        data.visitor_name ||
        data.nickName ||
        data.nickname ||
        payload.visitorName ||
        payload.visitor_name ||
        payload.nickName ||
        payload.nickname ||
        (data.user && (data.user.nickName || data.user.nickname)) ||
        '';
      if (n) {
        return String(n).trim();
      }
    }
    if (typeof window.customerName === 'string' && window.customerName.trim()) {
      return window.customerName.trim();
    }
    return '';
  }

  /** 与 public-api zendesk-ticket 的 visitorEmail 一致，写入 Zendesk requester（可选） */
  function pickVisitorEmail(data) {
    if (data && typeof data === 'object') {
      var payload = data.payload && typeof data.payload === 'object' ? data.payload : {};
      var e =
        data.visitorEmail ||
        data.visitor_email ||
        data.email ||
        payload.visitorEmail ||
        payload.visitor_email ||
        payload.email ||
        (data.user && (data.user.email || data.user.visitorEmail || data.user.visitor_email)) ||
        '';
      if (e && String(e).trim()) {
        return String(e).trim();
      }
    }
    if (typeof window.customerEmail === 'string' && window.customerEmail.trim()) {
      return window.customerEmail.trim();
    }
    return '';
  }

  /**
   * 打印转接时的关键 id（字段名随快牛回调可能变化；同时打出 data / payload 的键名便于核对）。
   */
  function logGoThirdPlatformTransferIds(data) {
    var ids = {
      chatSubSessionId: pickChatSubSessionId(data),
      visitorName: pickVisitorName(data),
      visitorEmail: pickVisitorEmail(data),
    };
    if (data && typeof data === 'object') {
      var payload = data.payload && typeof data.payload === 'object' ? data.payload : {};
      function first(keys) {
        for (var i = 0; i < keys.length; i++) {
          var k = keys[i];
          var v = data[k];
          if (v == null || !String(v).trim()) {
            v = payload[k];
          }
          if (v != null && String(v).trim()) {
            return String(v).trim();
          }
        }
        return '';
      }
      ids.chatSessionId = first(['chatSessionId', 'chat_session_id', 'sessionId', 'session_id']);
      ids.visitorId = first(['visitorId', 'visitor_id', 'vid']);
      ids.machineId = first([
        'machineId',
        'machine_id',
        'deviceId',
        'device_id',
        'clientId',
        'client_id',
        'equipmentId',
        'equipment_id',
      ]);
      ids.userId = first(['userId', 'user_id', 'uid', 'openId', 'open_id']);
      ids.robotId = first(['robotId', 'robot_id', 'botId', 'bot_id']);
      ids.shopId = first(['shopId', 'shop_id', 'storeId', 'store_id']);

      if (data.chatSession && data.chatSession.id != null && String(data.chatSession.id).trim()) {
        ids.chatSessionNestedId = String(data.chatSession.id).trim();
      }
      if (data.chatSubSession && data.chatSubSession.id != null && String(data.chatSubSession.id).trim()) {
        ids.chatSubSessionNestedId = String(data.chatSubSession.id).trim();
      }
    }

    if (typeof window.quickChatVisitorId === 'string' && window.quickChatVisitorId.trim()) {
      ids.window_quickChatVisitorId = window.quickChatVisitorId.trim();
    }

  }

  /**
   * Worker：`{ ok: true, ticket: <Zendesk Create Ticket 的 JSON> }`，常为 `{ ticket: { id } }` 包一层。
   */
  function extractPrefetchTicketIdFromTicketApi(body) {
    if (!body || body.ok !== true || !body.ticket) return null;
    var w = body.ticket;
    if (typeof w !== 'object') return null;
    if (w.ticket && typeof w.ticket === 'object' && w.ticket.id != null) {
      return String(w.ticket.id);
    }
    if (w.id != null) {
      return String(w.id);
    }
    return null;
  }

  function buildMessengerCorrelationFields(cfg, chatSubSessionId) {
    var ids =
      cfg.messengerConversationFieldIds && typeof cfg.messengerConversationFieldIds === 'object'
        ? cfg.messengerConversationFieldIds
        : {};
    var out = [];
    if (chatSubSessionId && ids.chatSubSessionId && String(ids.chatSubSessionId).trim()) {
      out.push({
        id: String(ids.chatSubSessionId).trim(),
        value: String(chatSubSessionId),
      });
    }
    return out;
  }

  /**
   * 通知你们后端预建 Zendesk 工单（内含快牛历史消息 HTML）。未配置 ticketApiUrl 或缺子会话 id 时跳过。
   * Body 与 tiger-public-api `POST …/zendesk-ticket` 一致：`chatSubSessionId`（必填）、`visitorName`、`visitorEmail`。
   * 若配置了 `getTicketFetchInit(defaultInit, ctx)`，可先异步补全 headers（例如短期 token），再发起 fetch；ctx 含 `url`、`body`。
   * @returns {Promise<{ ok: boolean, skipped?: boolean, status?: number, prefetchTicketId?: string }>}
   */
  function notifyBackendCreateTicketWithHistory(chatSubSessionId, visitorName, visitorEmail) {
    var cfg = window.UG_ZENDESK_TRANSFER_CONFIG || {};
    var url = cfg.ticketApiUrl;
    if (!url || typeof url !== 'string') {
      return Promise.resolve({ ok: true, skipped: true });
    }
    if (!chatSubSessionId) {
      return Promise.resolve({ ok: true, skipped: true });
    }

    var headers = Object.assign(
      {
        'Content-Type': 'application/json',
      },
      cfg.additionalHeaders || {},
    );

    var baseBody = {
      chatSubSessionId: chatSubSessionId,
      visitorName: visitorName || '访客',
    };
    if (visitorEmail && String(visitorEmail).trim()) {
      baseBody.visitorEmail = String(visitorEmail).trim();
    }
    var body = Object.assign(baseBody, cfg.additionalBodyFields || {});

    var fetchOpts = typeof cfg.fetchInit === 'object' && cfg.fetchInit !== null ? cfg.fetchInit : {};
    var defaultInit = {
      method: 'POST',
      credentials: cfg.credentials !== undefined ? cfg.credentials : 'same-origin',
      headers: headers,
      body: JSON.stringify(body),
    };
    var ctx = { url: url, body: body };

    function doFetch(finalInit) {
      return fetch(url, Object.assign({}, fetchOpts, finalInit))
        .then(function (res) {
          return res.text().then(function (text) {
            var outcome = {
              ok: res.ok,
              status: res.status,
              skipped: false,
            };
            if (!res.ok) {
              return outcome;
            }
            try {
              var j = text ? JSON.parse(text) : null;
              var tid = extractPrefetchTicketIdFromTicketApi(j);
              if (tid) {
                outcome.prefetchTicketId = tid;
              }
            } catch (e) {
              console.warn('[UG Zendesk] 预建工单响应解析失败', e);
            }
            return outcome;
          });
        })
        .catch(function (err) {
          return { ok: false, skipped: false };
        });
    }

    if (typeof cfg.getTicketFetchInit === 'function') {
      return Promise.resolve(cfg.getTicketFetchInit(defaultInit, ctx))
        .then(function (merged) {
          var init = merged && typeof merged === 'object' ? merged : defaultInit;
          return doFetch(init);
        })
        .catch(function (err) {
          return { ok: false, skipped: false };
        });
    }

    return doFetch(defaultInit);
  }

  /**
   * 转接 Zendesk 相关 UI 文案（小语种：仅改此对象对应字段即可）
   */
  const UG_ZENDESK_TRANSFER_COPY = {
    cornerLoading: 'Transferring...',
  };

  /* -----------------------------
   加载 Zendesk（只会加载一次）
  ------------------------------*/
  function loadZendesk(onReady, onError) {
    // 已经加载完成
    if (zendeskLoaded && window.zE) {
      onReady && onReady();
      return;
    }

    // 正在加载中（防止重复插入 script）
    if (zendeskLoading) {
      waitZendeskReady(onReady, onError);
      return;
    }

    zendeskLoading = true;

    const script = document.createElement('script');
    script.id = 'ze-snippet';
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${ZENDESK_KEY}`;
    script.async = true;

    script.onload = function () {

      waitZendeskReady(() => {
        zendeskLoaded = true;

        // 初始化：隐藏 launcher
        try {
          zE('messenger', 'hide');
        } catch (e) {
          console.warn('Zendesk init error', e);
        }

        onReady && onReady();
      }, onError);
    };

    script.onerror = function () {
      zendeskLoading = false;
      onError && onError();
    };

    document.head.appendChild(script);
  }

  /* -----------------------------
   等待 zE 可用（带超时）
  ------------------------------*/
  function waitZendeskReady(callback, onError) {
    const interval = 100;
    const timeout = 5000;
    let elapsed = 0;

    const timer = setInterval(function () {
      if (typeof window.zE === 'function') {
        clearInterval(timer);
        callback();
        return;
      }

      elapsed += interval;

      if (elapsed >= timeout) {
        clearInterval(timer);
        onError && onError();
      }
    }, interval);
  }

  /* -----------------------------
   转接 Zendesk：右下角 loading（左侧白底聊天气泡文案 + 右侧白底 48×48 圆内转圈）
  ------------------------------*/
  function showZendeskTransferCornerLoading() {
    let el = document.getElementById('ug-zendesk-transfer-corner-loading');
    if (!el) {
      el = document.createElement('div');
      el.id = 'ug-zendesk-transfer-corner-loading';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.setAttribute('aria-label', UG_ZENDESK_TRANSFER_COPY.cornerLoading);

      const bubble = document.createElement('div');
      bubble.className = 'ug-ztl-corner-loading-bubble';

      const label = document.createElement('span');
      label.className = 'ug-ztl-corner-loading-text';
      label.textContent = UG_ZENDESK_TRANSFER_COPY.cornerLoading;

      const orb = document.createElement('div');
      orb.className = 'ug-ztl-corner-loading-orb';

      const spinner = document.createElement('span');
      spinner.className = 'ug-ztl-spinner ug-ztl-spinner--corner';
      spinner.setAttribute('aria-hidden', 'true');

      bubble.appendChild(label);
      orb.appendChild(spinner);
      el.appendChild(bubble);
      el.appendChild(orb);

      el.style.cssText = `
        position: fixed;
        right: 18px;
        bottom: 50px;
        z-index: 2147483645;
        display: flex;
        align-items: center;
        flex-direction: row;
        gap: 0;
        background: transparent;
        padding: 0;
        pointer-events: none;
      `.trim();
      const style = document.createElement('style');
      style.textContent = `
        #ug-zendesk-transfer-corner-loading .ug-ztl-corner-loading-bubble {
          position: relative;
          display: flex;
          align-items: center;
          margin-right: 6px;
          padding: 7px 13px;
          border-radius: 10px;
          background: #fff;
          box-shadow:
            0 2px 10px rgba(0, 0, 0, 0.1),
            0 1px 3px rgba(0, 0, 0, 0.06);
        }
        #ug-zendesk-transfer-corner-loading .ug-ztl-corner-loading-text {
          font-size: 14px;
          color: #000;
          line-height: 1.3;
          white-space: nowrap;
          text-shadow: 0 0.5px 1px rgba(0, 0, 0, 0.06);
        }
        #ug-zendesk-transfer-corner-loading .ug-ztl-corner-loading-orb {
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 48px;
          height: 48px;
          border-radius: 50%;
          background: #fff;
          box-shadow:
            0 2px 10px rgba(0, 0, 0, 0.1),
            0 1px 3px rgba(0, 0, 0, 0.06);
        }
        #ug-zendesk-transfer-corner-loading .ug-ztl-spinner--corner {
          width: 22px;
          height: 22px;
          border: 2px solid #e8e8e8;
          border-top-color: #555;
          border-radius: 50%;
          animation: ug-ztl-spin 0.75s linear infinite;
        }
        @keyframes ug-ztl-spin {
          to {
            transform: rotate(360deg);
          }
        }
        @media screen and (max-width: 749px) {
          #ug-zendesk-transfer-corner-loading {
            right: 16px!important;
            bottom: 42px!important;
          }
        }
      `.trim();
      document.head.appendChild(style);
      document.body.appendChild(el);
    } else {
      el.setAttribute('aria-label', UG_ZENDESK_TRANSFER_COPY.cornerLoading);
      var textEl = el.querySelector('.ug-ztl-corner-loading-text');
      if (textEl) {
        textEl.textContent = UG_ZENDESK_TRANSFER_COPY.cornerLoading;
      }
    }
    el.style.display = 'flex';
  }

  function hideZendeskTransferCornerLoading() {
    const el = document.getElementById('ug-zendesk-transfer-corner-loading');
    if (el) {
      el.style.display = 'none';
    }
  }

  /**
   * 在 Zendesk 消息区域已展示后再回调（仅使用 messenger:on messagesShown）。
   * onReady：messagesShown 或 open 降级；onTimeout：仅兜底计时器触发（用于回开 QuickChat）。
   * @returns {function} 取消监听与超时（在 zE 抛错时调用，防止误触发）
   */
  function whenMessengerReadyForDisplay(opts) {
    var onReady = opts && opts.onReady;
    var onTimeout = opts && opts.onTimeout;
    var timeoutMsSafe = opts && opts.timeoutMs != null ? opts.timeoutMs : 15000;
    var finished = false;
    var unsubs = [];
    var timeoutId = null;

    function cleanupListeners() {
      unsubs.forEach(function (u) {
        if (typeof u === 'function') {
          try {
            u();
          } catch (e) {}
        }
      });
      unsubs = [];
    }

    function finishReady() {
      if (finished) {
        return;
      }
      finished = true;
      cleanupListeners();
      if (timeoutId != null) {
        clearTimeout(timeoutId);
      }
      onReady && onReady();
    }

    function pushUnsub(u) {
      if (typeof u === 'function') {
        unsubs.push(u);
      }
    }

    timeoutId = setTimeout(function () {
      if (!finished) {
        finished = true;
        cleanupListeners();
        onTimeout && onTimeout();
      }
    }, timeoutMsSafe);

    try {
      pushUnsub(
        zE('messenger:on', 'messagesShown', function () {
          finishReady();
        }),
      );
    } catch (e) {
      console.warn('[Zendesk] messenger:on messagesShown 订阅失败', e);
    }

    // 未挂上 messagesShown 时降级：open 后再等一小段时间（仍视为就绪，走 onReady）
    if (unsubs.length === 0) {
      try {
        pushUnsub(
          zE('messenger:on', 'open', function () {
            setTimeout(function () {
              if (!finished) {
                finishReady();
              }
            }, 600);
          }),
        );
      } catch (e2) {
        setTimeout(function () {
          if (!finished) {
            finishReady();
          }
        }, 600);
      }
    }

    return function cancel() {
      if (finished) {
        return;
      }
      finished = true;
      cleanupListeners();
      if (timeoutId != null) {
        clearTimeout(timeoutId);
      }
    };
  }

  /* -----------------------------
   打开 Zendesk
   options.onOpened：messagesShown（或 open 降级）后再回调
   options.onTimedOut：仅 messagesShown 兜底超时触发（不调用 onOpened）
   options.onFailed：加载/打开失败时回调（仍会执行原有 QuickChat fallback）
  ------------------------------*/
  function openZendesk(userInfo, options) {
    const onOpened = options && options.onOpened;
    const onTimedOut = options && options.onTimedOut;
    const onFailed = options && options.onFailed;
    const messengerWaitMs = options && options.messengerWaitTimeoutMs;

    loadZendesk(
      () => {
        var cancelWait = null;
        try {
          cancelWait = whenMessengerReadyForDisplay({
            timeoutMs: messengerWaitMs,
            onReady: function () {
              onOpened && onOpened();
            },
            onTimeout: function () {
              onTimedOut && onTimedOut();
            },
          });

          // 防重复打开
          if (zendeskOpened) {
            zE('messenger', 'open');
            return;
          }

          zendeskOpened = true;

          // 用户信息 + QuickCEP 子会话（conversationFields，与预建工单同一会话 id）
          if (userInfo) {
            const fields = [];

            if (userInfo.email) {
              fields.push({ id: 'email', value: userInfo.email });
            }

            if (userInfo.orderId) {
              fields.push({ id: 'order_id', value: userInfo.orderId });
            }

            var cfgForFields = window.UG_ZENDESK_TRANSFER_CONFIG || {};
            var corr = buildMessengerCorrelationFields(cfgForFields, userInfo.chatSubSessionId);
            for (var ci = 0; ci < corr.length; ci++) {
              fields.push(corr[ci]);
            }

            if (fields.length > 0) {
              zE('messenger:set', 'conversationFields', fields);
            }
          }

          // 打开聊天（就绪时机由 messenger:on messagesShown / 降级 / 超时 决定）
          zE('messenger', 'show');
          zE('messenger', 'open');
        } catch (e) {
          if (cancelWait) {
            cancelWait();
          }
          onFailed && onFailed();
          if (window.quickChatApi) {
            window.quickChatApi.chat && window.quickChatApi.chat();
          }
        }
      },
      () => {
        onFailed && onFailed();
        if (window.quickChatApi) {
          window.quickChatApi.chat && window.quickChatApi.chat();
        }
      },
    );
  }

  /* -----------------------------
   关闭 Zendesk
  ------------------------------*/
  function closeZendesk() {
    if (window.zE) {
      try {
        zE('messenger', 'close');
      } catch (e) {}
    }
  }

  /* -----------------------------
   QuickChat 接入
  ------------------------------*/
  window.quickChatReadyHook = function () {

    // 👉 转接 Zendesk（先按需预建工单 + 历史会话 HTML，再打开 Zendesk Messaging）
    window.quickEmitter.on('goThirdPlatform', function (data) {
      logGoThirdPlatformTransferIds(data);

      try {
        window.quickChatApi && window.quickChatApi.close();
      } catch (e) {}

      showZendeskTransferCornerLoading();

      var cfg = window.UG_ZENDESK_TRANSFER_CONFIG || {};
      var subSessionId = pickChatSubSessionId(data);
      var visitorName = pickVisitorName(data);
      var visitorEmail = pickVisitorEmail(data);

      notifyBackendCreateTicketWithHistory(subSessionId, visitorName, visitorEmail).then(function (ticketOutcome) {
        /** 预建工单失败且配置了不打开 messenger 时，回退 QuickChat */
        var hardFailStop =
          !ticketOutcome.skipped &&
          !ticketOutcome.ok &&
          cfg.openZendeskAfterTicketFails === false;

        if (hardFailStop) {
          hideZendeskTransferCornerLoading();
          try {
            window.quickChatApi && window.quickChatApi.chat && window.quickChatApi.chat();
          } catch (eOpen) {}
          if (typeof cfg.onTicketPrefetchFailed === 'function') {
            cfg.onTicketPrefetchFailed(ticketOutcome);
          }
          return;
        }

        openZendesk(
          {
            email: visitorEmail || window.customerEmail || '',
            orderId: window.lastOrderId || '',
            chatSubSessionId: subSessionId || '',
          },
          {
            onOpened: function () {
              hideZendeskTransferCornerLoading();
            },
            onTimedOut: function () {
              hideZendeskTransferCornerLoading();
              closeZendesk();
              try {
                window.quickChatApi && window.quickChatApi.chat && window.quickChatApi.chat();
              } catch (e) {}
            },
            onFailed: function () {
              hideZendeskTransferCornerLoading();
            },
          },
        );
      });
    });

    // 👉 回切 QuickChat
    window.quickEmitter.on('backToQuickChat', function () {

      closeZendesk();

      try {
        window.quickChatApi && window.quickChatApi.chat && window.quickChatApi.chat();
      } catch (e) {}
    });
  };

  function getQuickChatWindows() {
    var wins = [window];
    try {
      var iframe = document.getElementById('quick-chat-iframe');
      if (iframe && iframe.contentWindow) {
        wins.push(iframe.contentWindow);
      }
    } catch (e) {}
    return wins;
  }

  function getQuickChatApi() {
    var wins = getQuickChatWindows();
    for (var i = 0; i < wins.length; i++) {
      try {
        if (wins[i].quickChatApi) return wins[i].quickChatApi;
      } catch (e) {}
    }
    if (typeof quickChatApi !== 'undefined') return quickChatApi;
    return null;
  }

  function callQuickChatApi(api) {
    if (!api) return false;
    var methods = ['chat', 'open', 'startChat'];
    for (var i = 0; i < methods.length; i++) {
      if (typeof api[methods[i]] === 'function') {
        try {
          api[methods[i]]();
          return true;
        } catch (e) {}
      }
    }
    return false;
  }

  function findInitQuickChatUrl() {
    var existing = document.querySelector('script[src*="initQuickChat.js"]');
    if (existing && existing.src) return existing.src;

    var scripts = document.getElementsByTagName('script');
    for (var i = 0; i < scripts.length; i++) {
      var text = scripts[i].textContent || '';
      if (text.indexOf('initQuickChat.js') === -1) continue;
      var escaped = text.match(/https:\\\/\\\/chat\.quickcep\.com\\\/initQuickChat\.js[^"']+/);
      if (escaped) {
        return escaped[0].replace(/\\\//g, '/').replace(/\\u0026/g, '&');
      }
      var raw = text.match(/https:\/\/chat\.quickcep\.com\/initQuickChat\.js[^"'\\]+/);
      if (raw) return raw[0];
    }

    var shop = (window.Shopify && Shopify.shop) || '';
    var accessIds = {
      'ugreen-nas-uk.myshopify.com': '2fc06b04-26fe-4d6c-9ef8-335cd898d8e9',
    };
    if (shop && accessIds[shop]) {
      return (
        'https://chat.quickcep.com/initQuickChat.js?platform=shopify&accessId=' +
        accessIds[shop] +
        '&shop=' +
        encodeURIComponent(shop)
      );
    }
    return '';
  }

  function ensureInitQuickChat() {
    if (document.getElementById('ug-init-quickchat')) return;
    if (document.getElementById('quick-chat-iframe') && getQuickChatApi()) return;
    var url = findInitQuickChatUrl();
    if (!url) return;
    var script = document.createElement('script');
    script.id = 'ug-init-quickchat';
    script.src = url;
    script.async = true;
    document.head.appendChild(script);
  }

  function clickQuickChatLauncher() {
    var iframe = document.getElementById('quick-chat-iframe');
    if (!iframe) return false;
    try {
      var doc = iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document);
      if (!doc) return false;
      var nodes = doc.querySelectorAll('button, [role="button"], .mini-message');
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        var label = (el.getAttribute('aria-label') || '').toLowerCase();
        if (label === 'close') continue;
        el.click();
        return true;
      }
    } catch (e) {}
    return false;
  }

  function isQuickChatVisible() {
    var iframe = document.getElementById('quick-chat-iframe');
    if (!iframe) return false;
    var rect = iframe.getBoundingClientRect();
    return rect.width > 80 && rect.height > 80;
  }

  function tryOpenQuickCep() {
    var called = callQuickChatApi(getQuickChatApi());
    if (isQuickChatVisible()) return true;
    if (clickQuickChatLauncher() && isQuickChatVisible()) return true;
    return called && isQuickChatVisible();
  }

  window.UGopenLiveChat = function (event) {
    if (event && typeof event.preventDefault === 'function') {
      event.preventDefault();
    }

    if (tryOpenQuickCep()) {
      return;
    }

    ensureInitQuickChat();

    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (tryOpenQuickCep()) {
        clearInterval(timer);
        return;
      }
      if (tries === 8) {
        openZendesk(
          {
            email: window.customerEmail || '',
            orderId: window.lastOrderId || '',
          },
          {},
        );
      }
      if (tries > 40) {
        clearInterval(timer);
      }
    }, 200);
  };

  function isChatTrigger(el) {
    if (!el || !el.closest) return null;
    return el.closest('#Chat_btn, .js-chat-trigger');
  }

  document.addEventListener(
    'click',
    function (event) {
      if (!isChatTrigger(event.target)) return;
      window.UGopenLiveChat(event);
    },
    true,
  );
})();
